import { useEffect } from 'react';
import { message } from 'antd';

import { useSendVerificationCode as useSendVerificationCodeApi } from '../../../hooks/api/claimBusiness';
import { getMessageInError } from '../../../hooks/fetch';

const useSendVerificationCode = (id: string) => {
  const {
    fetch: sendVerificationCode, response, error, loading, clearError, clearResponse,
  } = useSendVerificationCodeApi(id);

  useEffect(() => {
    if (response?.data.success) {
      message.success('Verification code sent successfully');
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      message.error(getMessageInError(error));
    }
  }, [error]);

  const clear = () => {
    clearError();
    clearResponse();
  };

  return {
    sendVerificationCode,
    response,
    error,
    loading,
    clear,
  };
};

export default useSendVerificationCode;
